var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#5c2d91",
    r: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.82 9a32 32 0 1 0 45.18 45.18z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.4 41.25a1.35 1.35 0 0 1 -1-.42 1.38 1.38 0 0 1 -.41-1 1.4 1.4 0 0 1 .41-1 1.34 1.34 0 0 1 1-.43 1.37 1.37 0 0 1 1 .43 1.39 1.39 0 0 1 .42 1 1.37 1.37 0 0 1 -.42 1 1.38 1.38 0 0 1 -1 .42zm19.87-.25h-2.62l-9.37-14.54a6.06 6.06 0 0 1 -.58-1.14h-.08a18.71 18.71 0 0 1 .1 2.5v13.18h-2.13v-18.23h2.77l9.12 14.28q.57.89.74 1.22h.05a19.29 19.29 0 0 1 -.13-2.68v-12.82h2.13zm14.42 0h-9.69v-18.23h9.24v1.93h-7.06v6.06h6.58v1.92h-6.58v6.32h7.52zm14.31-16.3h-5.3v16.3h-2.13v-16.3h-5.24v-1.93h12.67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.38e9383cb617b6ea5a82e77162843fca.svg";
export { ForwardRef as ReactComponent };